const text = value => String(value ?? '').trim();
export const is99Food = order => text(order?.source).toLowerCase() === '99food';
export const flatten99Options = (options = [], depth = 0) => (Array.isArray(options) ? options : []).flatMap(option => [
  { ...option, depth }, ...flatten99Options(option.options, depth + 1),
]);
export const option99Total = option => option.totalPrice !== null && option.totalPrice !== undefined
  ? Number(option.totalPrice) : Number(option.unitPrice ?? option.price ?? 0) * Number(option.quantity || 1);
export const fallback99Items = items => (Array.isArray(items) ? items : []).map(item => ({
  name: text(item.name), quantity: Number(item.quantity || 1), unitPrice: Number(item.unitPrice ?? 0),
  totalPrice: option99Total(item), observations: text(item.observations),
  options: flatten99Options(item.options).map(option => ({
    name: `${'  '.repeat(option.depth || 0)}${text(option.name)}`, quantity: Number(option.quantity || 1),
    price: option99Total(option), observations: text(option.observations),
  })),
}));
export const address99 = order => {
  const customer = order?.customer || {};
  const a = { ...order?.delivery?.deliveryAddress, ...customer.addressInfo };
  const lines = [text(a.formattedAddress || customer.address) || [a.street, a.number].filter(Boolean).join(', ')];
  const append = (value, label = '') => {
    const part = text(value);
    if (part && !lines.join(' ').toLocaleLowerCase('pt-BR').includes(part.toLocaleLowerCase('pt-BR'))) lines.push(`${label}${part}`);
  };
  append(a.neighborhood); append([a.city, a.state].filter(Boolean).join(' - ')); append(a.postalCode);
  append(a.complement, 'Complemento: '); append(a.reference, 'Referência: ');
  return lines.filter(Boolean).join('\n');
};
const preferences = { 0: 'Sem preferência informada', 5: 'Entrar em contato com o cliente',
  6: 'Cancelar o pedido inteiro', 7: 'Reembolsar somente os itens indisponíveis' };
// Informational detail never recomputes the official total or confirms payment.
export function operational99Rows(order, money = value => Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), sections = ['instructions', 'stock', 'payment', 'price']) {
  if (!is99Food(order)) return [];
  const data = order.ninetyNineFood || {};
  const rows = [];
  if (sections.includes('instructions') && typeof data.needCutlery === 'boolean') rows.push(`Talheres: ${data.needCutlery ? 'Enviar' : 'Não enviar'}`);
  if (sections.includes('instructions') && data.cancellationPreference !== null && data.cancellationPreference !== undefined) rows.push(`Falta de item: ${preferences[data.cancellationPreference] || `Preferência não reconhecida (${data.cancellationPreference})`}`);
  if (sections.includes('stock') && data.inventoryMappingState === 'pending') rows.push('Estoque: há itens sem vínculo confirmado com o catálogo local. Confira o mapeamento.');
  const p = order.payments || {};
  if (sections.includes('payment') && Number(p.changeFor) > 0) {
    rows.push(`Troco para: ${money(p.changeFor)}`);
    if (p.change !== null && p.change !== undefined) rows.push(`Troco a devolver: ${money(p.change)}`);
  }
  if (sections.includes('payment') && p.provider?.changeForUnconfirmed === true) rows.push('O valor de troco informado pela 99Food precisa ser conferido com o cliente.');
  const labels = { itemsDiscount: 'Desconto dos itens', deliveryDiscount: 'Desconto da entrega', originalDelivery: 'Entrega antes dos descontos',
    smallOrder: 'Taxa de pedido pequeno', tips: 'Gorjeta', service: 'Taxa de serviço', couponDiscount: 'Desconto de cupom', minimumOrderTopUp: 'Complemento de pedido mínimo' };
  Object.entries(data.priceDetailsCents || {}).forEach(([key, cents]) => {
    if (sections.includes('price') && labels[key] && cents !== null && cents !== undefined) rows.push(`${labels[key]}: ${money(Number(cents) / 100)}`);
  });
  const promotions = (entries, label) => (Array.isArray(entries) ? entries : []).forEach((promo, i) => {
    if ((promo.type !== null && promo.type !== undefined) || (promo.discountCents !== null && promo.discountCents !== undefined)
      || (promo.merchantSubsidyCents !== null && promo.merchantSubsidyCents !== undefined)) {
      const parts = [`${label} ${i + 1}${promo.type === null || promo.type === undefined ? '' : ` (tipo ${promo.type})`}`];
      if (promo.discountCents !== null && promo.discountCents !== undefined) parts.push(`desconto ${money(promo.discountCents / 100)}`);
      if (promo.merchantSubsidyCents !== null && promo.merchantSubsidyCents !== undefined) parts.push(`participação da loja ${money(promo.merchantSubsidyCents / 100)}`);
      rows.push(parts.join(' — '));
    }
    promotions(promo.details, label);
  });
  const itemPromotions = items => (Array.isArray(items) ? items : []).forEach(item => {
    promotions(item.promotions, `Promoção de ${text(item.name) || 'item'}`); itemPromotions(item.options);
  });
  if (sections.includes('price')) { promotions(data.promotions, 'Promoção'); itemPromotions(order.items); }
  return rows;
}
